import { Helmet } from "react-helmet";
import Breadcrumb from "../components/Breadcrumb";
import classes from "./ReturnRefundPolicy.module.css";
import { Link } from "react-router-dom";

export default function ReturnRefundPolicy() {
  return (
    <>
      <Helmet>
        <title>
          Return & Refund Policy - How Server Stock UK Protects Your Personal
          Data
        </title>
        <meta
          name="description"
          content="At Server Stock UK, your privacy matters. Learn how we securely collect, use, and protect customer information while shopping for IT hardware online."
        />
        <link
          rel="canonical"
          href="https://www.serverstock.co.uk/refund-and-returns-policy"
        />
      </Helmet>

      <Breadcrumb currentPage="Return & Refund Policy" />
      <div className={`container ${classes.returnRefundContainer}`}>
        <p className={classes.paragraph}>
          We offer a 30-day return policy, this implies that once you receive
          the item, you have the flexibility to return it within a 30-day.
        </p>
        <p className={classes.paragraph}>
          To return the item, the item must meet the following criteria: it
          should be in its original packaging, unused, with tags, and
          accompanied by the receipt or proof of purchase. To initiate a return,
          please contact us at{" "}
          <Link to="mailto:sales@serverstock.co.uk">
            sales@serverstock.co.uk
          </Link>
          . Once your return is accepted, we will provide you with a shipping
          label and instructions on how and where to send your package. Please
          note that we do not accept returns that have not been requested in
          advance.
        </p>

        <h2 className={classes.subheading}>Terms</h2>

        <p className={classes.paragraph}>
          "Business Customer" refers to non-consumer customers, while "Consumer"
          refers to individuals not acting in a business or professional
          capacity.
        </p>
        <h2 className={classes.subheading}>Cancelation Policy</h2>

        <p className={classes.paragraph}>
          If you intend to cancel your order for any reason, a 24-hour period is
          allocated from the time of purchase for such requests. To initiate the
          cancellation process, please contact our esteemed customer success
          team via email at{" "}
          <Link to="mailto:sales@serverstock.co.uk">
            sales@serverstock.co.uk
          </Link>{" "}
          ensuring that you provide your order number and name in your
          communication. Upon receipt of your cancellation request, we will
          expeditiously process a refund to your original method of payment
          within 7 business days. 20% restocking fee will be applied.
        </p>

        <h2 className={classes.subheading}>Faulty Returns Conditions</h2>
        <p className={classes.paragraph}>
          If your product arrives damaged. kindly document the issue by
          capturing both photos and videos of the affected item. Subsequently,
          please forward the visual evidence to our dedicated customer service
          team at{" "}
          <Link to="mailto:support@serverstock.co.uk">
            support@serverstock.co.uk
          </Link>{" "}
          After a thorough examination and verification of the reported issue.
          You will be provided with two alternatives: either the prompt dispatch
          of a replacement product or a 100% refund.
        </p>

        <h2 className={classes.subheading}>
          Lost or stolen packages (if applicable)
        </h2>
        <p className={classes.paragraph}>
          Server Stock is not responsible for packages that may be lost or
          stolen post-delivery to the designated address for an order. However,
          upon the customer's request, Server Stock is committed to providing
          confirmation of the delivery date, tracking information, and carrier
          details, thereby facilitating the customer's inquiry.
        </p>

        <h2 className={classes.subheading}>Original condition:</h2>
        <p className={classes.paragraph}>
          Accessories, manuals, software, and warranties must be securely
          packaged in their original undamaged packaging.
        </p>

        <h2 className={classes.subheading}>Refund Time Period</h2>
        <p className={classes.paragraph}>
          If you haven't received your refund within 7 business days of our
          receipt of your return, we kindly request you to contact our customer
          success team. Feel free to reach out to us via email at should be{" "}
          <Link to="mailto:support@serverstock.co.uk">
            support@serverstock.co.uk
          </Link>{" "}
          , including your name and order number for expedited assistance. We
          assure you of a timely response within 12 hours and will promptly
          facilitate the refund process.
        </p>

        <h2 className={classes.subheading}>Goods Damaged during Transit:</h2>
        <p className={classes.paragraph}>
          If you haven't received your refund within 7 business days of our
          receipt of your return, we kindly request you to contact our customer
          success team. Feel free to reach out to us via email at should be{" "}
          <Link to="mailto:support@serverstock.co.uk">
            support@serverstock.co.uk
          </Link>{" "}
          If you notice any visible damage to the goods or products on the
          receipt, It is essential to formally acknowledge and record them as
          damaged upon receipt from the courier. We kindly request immediate
          initiation of contact us at{" "}
          <Link to="tel:+442475420877">+44 247 542 0877</Link> . or via email at{" "}
          <Link to="mailto:support@serverstock.co.uk">
            support@serverstock.co.uk
          </Link>{" "}
          For products incurring damage during transit, we earnestly request
          that such incidents be reported to us within two business days of
          delivery.
        </p>

        <h2 className={classes.subheading}>Non-Working or defect after use:</h2>
        <p className={classes.paragraph}>
          If you experience any issues with your product, we kindly request that
          you notify us within 30 days from the date of its arrival. In the
          event of a defective or malfunctioning product during this period, you
          may proceed with the return. Upon receipt, our team will conduct
          thorough testing and inspection. If the issue is rectifiable, we will
          promptly address and resolve it. However, if the problem proves
          unfixable, we commit to expeditiously dispatching a replacement unit.
          In the unlikely scenario where a replacement unit is unavailable, a
          full refund will be promptly issued.
        </p>

        <h2 className={classes.subheading}>Refund Requirements:</h2>
        <p className={classes.paragraph}>
          Refunds will be processed to your original payment method within 5 to
          7 business days. Promotions and discounts, once applied, are
          considered non-refundable.
        </p>

        <h2 className={classes.subheading}>Our Return Delivery Address</h2>
        <p className={classes.paragraph}>
          <strong>location: </strong>Unit #5, The Hub, A53-61 College Road,
          Harrow, HA1 1AR
        </p>

        <p className={classes.paragraph}>
          <strong>Technical Support: </strong>{" "}
          <Link to="mailto:support@serverstock.co.uk">
            support@serverstock.co.uk
          </Link>{" "}
        </p>

        <p className={classes.paragraph}>
          <strong>Phone: </strong>{" "}
          <Link to="tel:+442475420877">+44 247 542 0877</Link>{" "}
        </p>
      </div>
    </>
  );
}
